import { LocalService } from './../storage/local.service';
import { EmitService } from './emit.service';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as $ from 'jquery';


@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor(
    private localSecureService: LocalService
  ) { }

  swalErrorLogin(title: string, subTitle: string, text: string) {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                          <img src="assets/img/alert.svg">
                          <h3 class="mt-2">${title}</h3>
                          <hr class="w-50 mx-auto">
                          <h6 class="mt-2">${subTitle}</h6>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>${text}</h5>
                          </div>
                      </div>
                    </div>`
    Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      showConfirmButton: false,
      timer: 3000
    });
  }

  async swalError(title: string, subTitle: string, text: string) {
    let response = false;
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                          <img src="assets/img/alert.svg">
                          <h3 class="mt-2">${title}</h3>
                          <hr class="w-50 mx-auto">
                          <h6 class="mt-2">${subTitle}</h6>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>${text}</h5>
                          </div>
                          <div class="row mx-auto">
                          <div class="col-12 text-center">
                              <button type="button" class="btn-color" id="cerrarMensaje">OK</button>
                          </div>
                          </div>
                      </div>
                    </div>`
    $(document).on('click', "#cerrarMensaje", this.swalClose);
   await Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      showConfirmButton: false,
    }).then((result: any) => {
      response = result.isConfirmed;
    });
    return response;
  }

  swalRellamar(ejecutivo: any) {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">
                          <button type="button" class="btn-close" id="cerrarMensaje"></button>
                      </div>
                      <div class="modal-body pb-5">
                          <img src="assets/img/user-white.svg">
                          <h3 class="mt-2">${ejecutivo}</h3>
                          <hr class="w-75 mx-auto">
                          <h2>Rellamando</h2>
                      </div>
                      <div class="modal-footer">
                          <div class="notificacion">
                              <img src="./assets/img/notification.gif">
                          </div>
                      </div>
                  </div>`
    Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      showConfirmButton: false,
      timer: 5000
    });
    $(document).on('click', "#cerrarMensaje", this.swalClose);
  }

  swalAnular(subTitle: string) {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                          <img src="assets/img/alert.svg">
                          <h3 class="mt-2">Llamado anulado!</h3>
                          <hr class="w-50 mx-auto">
                          <h6 class="mt-2">${subTitle}</h6>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>Se procederá al llamado del siguiente turno en espera o al momento de generarse</h5>
                          </div>
                      </div>
                    </div>`
    Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      showConfirmButton: false,
      timer: 3000
    });
  }

  
  async swalSuccess(client: string) {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                          <img src="assets/img/user-white.svg">
                          <h3 class="mt-2">¡Éxito!</h3>
                          <hr class="w-50 mx-auto">
                          <h6 class="mt-2">Registro ingresado exitosamente.</h6>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>Se ha agregado a ${client} a la lista de llamados.</h5>
                          </div>
                      </div>
                    </div>`
    await Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      showConfirmButton: false,
      timer: 3000
    });
  }

  swalLoading(): void {
    const html = '<div><img src="./assets/img/loading1.gif" width="100px"></div>';
    Swal.fire({
      html,
      position: 'center',
      showConfirmButton: false,
      background: 'bottom',
      backdrop: 'rgba(255,255,255,0.7)',
      allowOutsideClick: false
    });
  }

  swalClose(): void {
    Swal.close();
  }

  swal500(): void {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: 'error',
      title: 'La solicitud no se ha podido completar. Intente nuevamente',
    })
  }

  toastError(title: string): void {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    })

    Toast.fire({
      icon: 'error',
      title,
    })
  }

  swalFin() {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                      <img src="assets/img/alert.svg">
                      <h3 class="mt-2">El cliente ha finalizado la videollamada</h3>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>No olvides Finalizar la Atención</h5>
                          </div>
                      </div>
                    </div>`
    Swal.fire({
      //width: 550,
      html,
      position: 'center',
      background: 'transparent',
      backdrop: 'rgba(255,255,255,0.7)',
      showConfirmButton: false,
      timer: 5000
    });
  }

  async swalInternet() {
    const html = `<div class="modal-content">
                      <div class="modal-header text-center">

                      </div>
                      <div class="modal-body pb-5">
                          <img src="">
                          <h3 class="mt-2">¡Lo sentimos!</h3>
                          <hr class="w-50 mx-auto">
                          <h6 class="mt-2">¡Sin conexión a internet!</h6>
                      </div>
                      <div class="modal-footer">
                          <div class="row mx-auto">
                              <h5>Su equipo se encuentra sin conexión a internet, favor espera que su conexión se reestablezca para ejecutar esta acción</h5>
                          </div>
                          <div class="row mx-auto">
                          <div class="col-12 text-center">
                              <button type="button" class="btn-color" id="cerrarMensaje">OK</button>
                          </div>
                          </div>
                      </div>
                    </div>`
    $(document).on('click', "#cerrarMensaje", this.swalClose);
   await Swal.fire({
      width: 550,
      html,
      position: 'center',
      background: 'transparent',
      timer: 5000,
      showConfirmButton: false,
    });

  }
}
